import React from "react";

import { cn } from "~/lib/cn";
import { Feature, hasFeature } from "~/lib/has-feature";
import type { MembershipPlan } from "~/lib/schemas/db-enums";

import { CDNImage } from "./cdn-image";
import { ScoreBadge } from "./score-badge";

/** A coach's photo with an optional match-score badge on top. */
export const CoachProfileImage = ({
  coach,
  profilePictureUrl,
  fullName,
  score,
  fallbackScore,
  isScoreBlurred = false,
  onScoreClick,
  scoreBadgeSize = "default",
}: {
  coach: { membershipPlan: MembershipPlan };
  profilePictureUrl?: string | null;
  fullName: string;
  score?: number | null;
  fallbackScore?: number | null;
  isScoreBlurred?: boolean;
  onScoreClick?: () => void;
  scoreBadgeSize?: "sm" | "default" | "lg";
}) => {
  const imgClass = cn(
    "mx-auto aspect-square rounded-full object-cover",
    hasFeature(coach, Feature.FancyProfile)
      ? "border-gradient-pro-purple animate-bg-gradient border-4"
      : "",
  );

  const displayScore = score ?? fallbackScore;
  const shouldShowScore = typeof displayScore === "number";
  const blurredScore = isScoreBlurred;

  return (
    <div className="relative">
      {profilePictureUrl ? (
        <CDNImage
          src={profilePictureUrl}
          alt={fullName}
          width={200}
          height={200}
          className={imgClass}
        />
      ) : (
        <div className={cn(imgClass, "bg-gray-400/20")} />
      )}
      {shouldShowScore && (
        <ScoreBadge
          score={Math.round(displayScore)}
          isBlurred={blurredScore}
          onClick={blurredScore ? onScoreClick : undefined}
          size={scoreBadgeSize}
        />
      )}
    </div>
  );
};
